import { useRoleActionDialog as useRoleActionDialogBase } from '../../_shared/useRoleActionDialog';
import { useCoreRolesArchiveMutation } from '../_graphql/useCoreRolesArchiveMutation';
import { useCoreRolesRestoreMutation } from '../_graphql/useCoreRolesRestoreMutation';

import { useTranslations } from '~/modules/settings/i18n/useTranslations';

export type { RoleActionDialogState } from '../../_shared/RoleActionConfirmationDialog';

type UseRoleActionDialogOptions = {
  onSuccess?: (
    actionType: 'archive' | 'restore' | 'bulkArchive' | 'bulkRestore',
  ) => void;
};

export function useRoleActionDialog(options?: UseRoleActionDialogOptions) {
  const t = useTranslations();
  const archiveMutation = useCoreRolesArchiveMutation();
  const restoreMutation = useCoreRolesRestoreMutation();

  return useRoleActionDialogBase({
    archiveMutation,
    restoreMutation,
    toastMessages: {
      archiveSuccess: (name) =>
        t.teamAndPermissions.roles.dialogs.archive.success(name),
      restoreSuccess: (name) =>
        t.teamAndPermissions.roles.dialogs.restore.success(name),
      bulkArchiveSuccess: (count) =>
        t.teamAndPermissions.roles.dialogs.bulkArchive.success(count),
      bulkRestoreSuccess: (count) =>
        t.teamAndPermissions.roles.dialogs.bulkRestore.success(count),
      error: t.teamAndPermissions.roles.addRoleDialog.messages.error,
    },
    onSuccess: options?.onSuccess,
  });
}
